import { AdId } from '../../contexts'
import { IBanner } from '../../types'
import { Container } from './Banner.styles'
import Ad from '../../sharedComponents/Ads/Ad'

export interface IProps {
  banner: IBanner
  collapse: boolean
}

export const Banner = ({ banner, collapse }: IProps) => {
  const id = banner.banner as AdId
  return (
    <Container>
      <Ad id={id} collapse={collapse} />
    </Container>
  )
}
